import createValues from './createValues';
import plain from './structure/plain';

export default createValues(plain);


//////////////////
// WEBPACK FOOTER
// ./node_modules/redux-form/es/values.js
// module id = 1111
// module chunks = 0